import React, {Component} from 'react'
import {styleNumberMessage} from './style-number-message'
import {Grid} from 'semantic-ui-react'
import {familyIdInput} from '../family-id-input'
import {colorInput} from '../color-input'

class GraphicsForm extends Component
{
  constructor(props)
  {
    super(props)
    this.state = {
      familyId: '0000',
      color: '300'
    }

    this.fieldOnChange = this.fieldOnChange.bind(this)
  }

  fieldOnChange(event, {value, name}) {
    let newState = {}
    if (name == 'familyId') {
      value = value.substring(0, 4)
    }

    if (name == 'color') {
      value = value.substring(0, 3)
    }
    newState[name] = value
    this.setState(newState)
  }

  render() {
    let {show} = this.props
    let {familyId, color} = this.state

    return (
      <div style={show ? {} : {display: 'none'}}>
        {styleNumberMessage(familyId, color, null, null)}

        <Grid divided columns={2} style={{fontSize: '120%', marginTop: 0}}>
          <Grid.Row>
            <Grid.Column style={{paddingLeft: '32px', paddingTop: '25px'}}>
              {familyIdInput(familyId, this.fieldOnChange, null, null)}
            </Grid.Column>
            <Grid.Column style={{paddingBottom: '50px', paddingLeft: '32px', paddingTop: '25px'}}>
              {colorInput(color, this.fieldOnChange)}
            </Grid.Column>
          </Grid.Row>
        </Grid>

      </div>
    )
  }
}

export default GraphicsForm
